<template>
    <div v-if="componentShow">
        <el-date-picker v-if="dateType == 'date'"
                        v-model="newValue" :disabled="disabled" :editable=false
                        align="right" @change="newValue=$event"
                        type="date" value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions1">
        </el-date-picker>
        <el-date-picker v-if="dateType == 'daterange'"
                        v-model="newValue" :disabled="disabled" :editable=false
                        type="daterange" @change="rangeChange" @focus="rangeFocus"
                        align="right" value-format="yyyy-MM-dd"
                        unlink-panels
                        range-separator="-"
                        :start-placeholder="$t(i18nPage+'开始日期')"
                        :end-placeholder="$t(i18nPage+'结束日期')"
                        :picker-options="pickerOptions2">
        </el-date-picker>
        <el-date-picker v-if="dateType == 'datetime'"
                        v-model="newValue" :disabled="disabled" :editable=false
                        type="datetime" @change="newValue=$event" 
                        align="right" :format="format" value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions1">
        </el-date-picker>
        <el-date-picker v-if="dateType == 'datetimerange'" ref="zmdtrange"
                        v-model="newValue" :disabled="disabled" :editable=false
                        type="datetimerange" @change="rangeChange" @focus="rangeFocus"
                        unlink-panels :format="format" value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions2"
                        :default-time="defaultTime"
                        range-separator="-"
                        :start-placeholder="$t(i18nPage+'开始日期')"
                        :end-placeholder="$t(i18nPage+'结束日期')"
                        align="right">
        </el-date-picker>
    </div>
</template>

<script>
    export default {
        name: "ZmDate",
        beforeCreate() {
            this.i18nPage = 'component.ZmDate.';
        },
        props: {
            dateType:{
                type:String,
                default:'date'
            },
            value:{
                type:[Date,String,Array,Number]
            },
            disabled:{
                type:Boolean,
                default:false
            },
            format:{
                type:String,
                default:'yyyy-MM-dd HH:mm:ss'
            },
            maxRange:{
                type:Number,
                default:180
            },
            isDefault:{
                type:Boolean,
                default:true
            }
        },
        data(){
            return {
                i18nPage : 'component.ZmDate.',
                componentShow:true,
                beforeFocusDate:null,
                initLoding:false,
                defaultTime:['00:00:00','00:00:00'],
                pickerOptions1: {
                    /*disabledDate(time) {
                        return time.getTime() > Date.now();
                    },*/
                    shortcuts: [{
                        text: this.$t(this.i18nPage+'今天'),
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: this.$t(this.i18nPage+'昨天'),
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: this.$t(this.i18nPage+'一周前'),
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: this.$t(this.i18nPage+'一月前'),
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', date);
                        }
                    }]
                },
                pickerOptions2: {
                    shortcuts: [{
                        text: this.$t(this.i18nPage+'当天'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            if(picker && picker.value && picker.value.length == 2){
                                let oldData = picker.value;
                                start.setHours(oldData[0].getHours());
                                start.setMinutes(oldData[0].getMinutes());
                                start.setSeconds(oldData[0].getSeconds());
                                end.setHours(oldData[1].getHours());
                                end.setMinutes(oldData[1].getMinutes());
                                end.setSeconds(oldData[1].getSeconds());
                            }
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: this.$t(this.i18nPage+'最近一周'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            if(picker && picker.value && picker.value.length == 2){
                                let oldData = picker.value;
                                start.setHours(oldData[0].getHours());
                                start.setMinutes(oldData[0].getMinutes());
                                start.setSeconds(oldData[0].getSeconds());
                                end.setHours(oldData[1].getHours());
                                end.setMinutes(oldData[1].getMinutes());
                                end.setSeconds(oldData[1].getSeconds());
                            }
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: this.$t(this.i18nPage+'最近一个月'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            if(picker && picker.value && picker.value.length == 2){
                                let oldData = picker.value;
                                start.setHours(oldData[0].getHours());
                                start.setMinutes(oldData[0].getMinutes());
                                start.setSeconds(oldData[0].getSeconds());
                                end.setHours(oldData[1].getHours());
                                end.setMinutes(oldData[1].getMinutes());
                                end.setSeconds(oldData[1].getSeconds());
                            }
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: this.$t(this.i18nPage+'最近三个月'),
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            if(picker && picker.value && picker.value.length == 2){
                                let oldData = picker.value;
                                start.setHours(oldData[0].getHours());
                                start.setMinutes(oldData[0].getMinutes());
                                start.setSeconds(oldData[0].getSeconds());
                                end.setHours(oldData[1].getHours());
                                end.setMinutes(oldData[1].getMinutes());
                                end.setSeconds(oldData[1].getSeconds());
                            }
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                }
            }
        },
        computed:{
            newValue: {
                get:function() {
                    return this.value;
                },
                set:function(value) {
                    if(this.dateType == 'datetimerange'){
                        if(value && value.length == 2){
                            this.defaultTime = [value[0].substring(11),value[1].substring(11)];
                        }else{
                            this.defaultTime = ['00:00:00','00:00:00'];
                        }
                        if(this.initLoding){
                            this.$nextTick(() => {
                                this.$refs['zmdtrange'].picker.defaultTime = this.defaultTime;
                            })
                        }else{
                            this.initLoding = true;
                        }
                    }
                    this.$emit('input', value);
                }
            }
        },
        methods: {
            rangeChange($event){
                this.newValue = $event;
                let cflag = true;
                if($event){
                    let startDate = $event[0];
                    let endDate = $event[1];
                    // date = date.substring(0,19);
                    startDate = startDate.replace(/-/g,'/');
                    endDate = endDate.replace(/-/g,'/');

                    let beginDate = new Date(startDate);
                    let eDate = new Date(endDate);

                    let bh = beginDate.getHours();
                    let bm = beginDate.getMinutes();
                    let bs = beginDate.getSeconds();
                    let eh = eDate.getHours();
                    let em = eDate.getMinutes();
                    let es = eDate.getSeconds();
                    let bjian = (bh > 0 ?  (3600 * 1000 * bh) : 0) + (bm > 0 ? (60 * 1000 * bm) : 0) + (bs > 0 ? (1000 * bs) : 0);
                    let ejian = (eh > 0 ?  (3600 * 1000 * eh) : 0) + (em > 0 ? (60 * 1000 * em) : 0) + (es > 0 ? (1000 * es) : 0);
                    let startTimestamp = beginDate.getTime();
                    let endTimestamp = eDate.getTime();
                    if(((endTimestamp-ejian) - (startTimestamp-bjian)) > (3600 * 1000 * 24 * this.maxRange)){
                        this.$util.show(this.$t(this.i18nPage+'日期跨度不能超过')+this.maxRange+this.$t(this.i18nPage+'天'),1);
                        // this.newValue = null;
                        this.newValue = this.beforeFocusDate;
                        cflag = false;
                    }
                }
                if(cflag){
                    this.$emit('change',$event);
                }
            },
            rangeFocus(res){
                if(res && res.value){
                    this.beforeFocusDate = res.value;
                }else{
                    this.beforeFocusDate = null;
                }
            }

        },
        created(){
            if(this.isDefault && (!this.value || this.value.length == 0)){
                if(this.dateType == 'date'){
                    this.newValue = this.$date.initDate();
                }else if(this.dateType == 'daterange'){
                    this.newValue = [this.$date.initDate(-30), this.$date.initDate()];
                }else if(this.dateType == 'datetime'){
                    this.newValue = this.$date.initDateFirst(0,true);
                }else{
                    // const end = new Date();
                    // const start = new Date();
                    // start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    this.newValue =[this.$date.initDateFirst(-30,true), this.$date.initDateEnd(0,true)]
                }
            }
            if(this.value && this.value.length == 2 && this.dateType == 'datetimerange'){
                this.newValue =[this.value[0], this.value[1]]
            }
        },
        beforeDestroy(){
            this.componentShow = false;
        }
    };
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ZmDate/index.vue